import Tip from '../../models/Tip';
import { Comps } from '../../collections/Comps';

export class CompsTips extends Comps {
	get model() {
		return Tip;
	}

	showCompsTips( data = {} ) {
		this.url = 'tips';

		return this.fetch( { data } ).then( response => {
			let count_leagues = response.result.length;
			this.trigger('get:response:leagues:count', count_leagues);
		} );
	}
}

export default CompsTips;